var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"mb-3 text-center d-lg-none"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.toggleFilters}},[_vm._v("TOGGLE FILTERS")])]),_vm._v(" "),_c('div',{staticClass:"d-lg-block",class:{ 'd-none': !_vm.displayFilters }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }